const memberJoiningTeam = state => state.memberJoiningTeam;
const teamDiscussionLoaded = state => state.teamDiscussionLoaded;
const teamDiscussion = state => state.teamDiscussion;
const addCreatorToTeam = state => state.addCreatorToTeam;
const teamMembersInviteMode = state => state.teamMembersInviteMode;

export default {
  memberJoiningTeam,
  teamDiscussionLoaded,
  teamDiscussion,
  addCreatorToTeam,
  teamMembersInviteMode
};
